import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import koCommon from "./locales/ko/common.json";
import koStudy from "./locales/ko/study.json";
import koCarddeck from "./locales/ko/carddeck.json";
import koStore from "./locales/ko/store.json";
import koMypage from "./locales/ko/mypage.json";
import koAuth from "./locales/ko/auth.json";
import koPurchase from "./locales/ko/purchase.json";
import koErrors from "./locales/ko/errors.json";
import koHome from "./locales/ko/home.json";
import koSurvey from "./locales/ko/survey.json";
import koOnboarding from "./locales/ko/onboarding.json";
import koClassroom from "./locales/ko/classroom.json";

import enCommon from "./locales/en/common.json";
import enStudy from "./locales/en/study.json";
import enCarddeck from "./locales/en/carddeck.json";
import enStore from "./locales/en/store.json";
import enMypage from "./locales/en/mypage.json";
import enAuth from "./locales/en/auth.json";
import enPurchase from "./locales/en/purchase.json";
import enErrors from "./locales/en/errors.json";
import enHome from "./locales/en/home.json";
import enSurvey from "./locales/en/survey.json";
import enOnboarding from "./locales/en/onboarding.json";
import enClassroom from "./locales/en/classroom.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ko: {
        common: koCommon,
        study: koStudy,
        carddeck: koCarddeck,
        store: koStore,
        mypage: koMypage,
        auth: koAuth,
        purchase: koPurchase,
        errors: koErrors,
        home: koHome,
        survey: koSurvey,
        onboarding: koOnboarding,
        classroom: koClassroom,
      },
      en: {
        common: enCommon,
        study: enStudy,
        carddeck: enCarddeck,
        store: enStore,
        mypage: enMypage,
        auth: enAuth,
        purchase: enPurchase,
        errors: enErrors,
        home: enHome,
        survey: enSurvey,
        onboarding: enOnboarding,
        classroom: enClassroom,
      },
    },
    defaultNS: "common",
    ns: [
      "common",
      "study",
      "carddeck",
      "store",
      "mypage",
      "auth",
      "purchase",
      "errors",
      "home",
      "survey",
      "onboarding",
      "classroom",
    ],
    supportedLngs: ["ko", "en"],
    nonExplicitSupportedLngs: true,
    fallbackLng: "en",
    load: "languageOnly",
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
    debug: process.env.NODE_ENV === "development",
  });

export default i18n;
